// import * as d3 from "d3";

import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axios'
import InviteForm from './../App/InviteForm';
import {uploadSvgAsImageToS3} from './../../FamilyTree/SaveTreeInS3'
import { downloadSvgAsImage } from './../../FamilyTree/svgUtils';
import { setupSvg,treeFit } from "./../../FamilyTree/view/View.handlers.js"
import download from "./../../assets/images/download.png"
import ModeToggleButton from './ToggleButton'
import { sendEventToFlutter } from './FamilyTree.js';
import { MAX_DOWNLOAD_LIMIT } from '../../constants.js';
import {
  API_BASE_URL,
  API_KEY,
  s3ApiUrl
} from '../../constants.js';
import { callFlutterHandler } from '../../FlutterHandler.js';
function Invite(props) {
  const { isOpen, onClose, onInvite, onCancel, mobile, onInputChange, familyChartElement,memberFamilyName,isBefore,storeValue,fitTree,DownloadSubscriber } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
   const [member_id, setMemberId] = useState(() => {
    // Initial fallback from URL
    return window.location.href.split('/')[4] || '';
  });

  
  const [selectLanguage, setselectLanguage] = useState({});
  const [selectCurrency,setselectCurrency]=useState({});
  const [flag,setFlag]=useState(false);
  const [popupStep, setPopupStep]=useState('initial');
  const [hasExceededLimit, setHasExceededLimit]=useState(false)
  let language=""  
  let currency=""
  const [exportType, setExportType] = useState({ value: 'png', label: 'PNG' });


  useEffect(() => {
    async function fetchMemberId() {
      try {
        const result = await window.flutter_inappwebview.callHandler(
          'getLocalStorageData',
          'login_member_id'
        );
        if (result) {
          setMemberId(result);  // 🔁 update state when available
        }
      } catch (error) {
        console.error('Error fetching member ID:', error);
      }
    }

    // Only try if flutter_inappwebview is available
    if (window.flutter_inappwebview) {
      fetchMemberId();
    }
  }, []);
  function waitForViewBoxToStabilize(svg, maxChecks = 20) {
  return new Promise((resolve) => {
    let last = null;
    let count = 0;

    const check = () => {
      const vb = svg.getAttribute("viewBox");
      if (vb === last && last !== null) {
        resolve();
      } else if (count >= maxChecks) {
        resolve(); // fail-safe
      } else {
        last = vb;
        count++;
        requestAnimationFrame(check);
      }
    };

    check();
  });
}

  const initiateDownload = async (include_watermark, language, isFitTreeChecked) => {
  let familyChartElement = document.getElementById("FamilyChart");
  familyChartElement.style.overflow = "auto";

  let svg = familyChartElement.querySelector("svg");
  const fit_tree = isFitTreeChecked;

  const bounding = {
    bottom: 851.5,
    height: 693.5,
    left: 1.2625000476837158,
    right: 1534.7250244617462,
    top: 158,
    width: 1533.4625244140625,
    x: 1.2625000476837158,
    y: 158,
  };

  if (svg) {
    const tree = { ...window.tree };

    // Setup SVG instantly
    setupSvg(svg, undefined, fit_tree, tree.dim);

    // Fit instantly (transition=0)
    treeFit({
      svg,
      svg_dim: bounding,
      tree_dim: tree.dim,
      transition: 0, // <--- instant layout change
      framePadding: { left: 15, right: 15, top: 15, bottom: 15 },
      fit_tree,
    });
  }

  // Re-query to ensure the DOM is updated
  svg = document.querySelector("#FamilyChart svg");
  await waitForViewBoxToStabilize(svg);

  const id = member_id;

  const newURL = new URL(window.location.href);
  newURL.search = "";
  newURL.searchParams.append("member_id", id);
  newURL.searchParams.append("event", "download");

  uploadSvgAsImageToS3(
    svg,
    id,
    newURL,
    memberFamilyName,
    "app",
    include_watermark || fitTree,
    bounding,
    language,
    fit_tree,
    window.tree?.dim,
    props.isBefore,
    exportType?.value || "pdf"
  );

  // Close modal instantly
  closeModal();
};


  const passPaymentEventToApp = (currency_val) => {
    console.log(currency_val)
    const newURL = new URL(window.location.href);
    newURL.search = '';
    // const member_id = window.location.href.split('/')[4];
    axiosInstance.put(`${API_BASE_URL}user-settings/${member_id}`,{'currency_id':currency_val.id} )
    // if(props.isBefore){
    //   newURL.searchParams.append('event', 'trigger_payment');
    //   newURL.searchParams.append('currency',currency_val.code)
    //   newURL.searchParams.append('amount',currency_val.value );
    //   window.location.href = newURL.href;
    // }
    setModalOpen(false)
    sendEventToFlutter("trigger_payment", {"d":{"data":{"id":member_id}},isBefore:props.isBefore}, { currency_val: currency_val})

    // callFlutterHandler('communicationname',{"event":"trigger_payment"})
  };

  const handleInvite = () => {
    // const member_id = window.location.href.split('/')[4];
    axiosInstance.get(API_BASE_URL+"check-subscription/"+member_id+"/").then((response)=>{
      console.log(response)
      if(response.data){
        if(response.data.currency_details &&  Object.keys(response.data.currency_details).length > 0){
          setselectCurrency({currency:{ value: response.data.currency_details.symbol,
            label: `${response.data.currency_details.symbol}-${response.data.currency_details.name}`,
            id: response.data.currency_details.id,code:response.data.currency_details.code}})
        }
        else{
          setselectCurrency({currency:{  value:'₹72',
            label:'₹72 - Indian Rupee',
            id:5,code:'INR'}})
        }
        if(response.data.font_family_details){
          if(response.data.font_family_details.language=="English"){
            setExportType({ value: 'pdf', label: 'PDF' })
          }
          language={value:response.data.font_family_details.font_family, label:response.data.font_family_details.language,id:response.data.font_family_details.id,bg_color:response.data.font_family_details.bg_color,bg_image:response.data.font_family_details.bg_image}
          setselectLanguage({
            language: { value:response.data.font_family_details.font_family, label:response.data.font_family_details.language,id:response.data.font_family_details.id,bg_color:response.data.font_family_details.bg_color,bg_image:response.data.font_family_details.bg_image}
          })
      }
      else{
        language={value:'Arial, Helvetica, sans-serif', label: 'English',id:15,bg_color:'',bg_image:false }
        setselectLanguage({
          language: { value:'Arial, Helvetica, sans-serif', label: 'English',id:15,bg_color:'',bg_image:false }
        })
      }
        if(response.data.is_subscriber==true||fitTree){
          setPopupStep("free")
          setFlag(true)
          setModalOpen(true)
          
          // initiateDownload(true,language,true);
        }
        else{
          if(response.data.free_download_count>=MAX_DOWNLOAD_LIMIT){
            setHasExceededLimit(true)
            setModalOpen(true)
            setPopupStep('buy')
          }
          else{
            setFlag(false)
            setModalOpen(true)
          }
           
        }
      }
});    
  };
  
  const handleCancel = () => {
    console.log('Cancel button clicked');
    // Add your logic for the cancel button click here
    closeModal(); // Close the modal after handling the cancel logic
  };

  const handleInputChange = (e) => {
    onInputChange(e); // Use the onInputChange function from props
  };

  const svgContent = ` <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <path d="M20 19V17H4V19H20M12 2C12.55 2 13 2.45 13 3V13.35L15.79 10.57L17.21 11.99L12 17.21L6.79 11.99L8.21 10.57L11 13.36V3C11 2.45 11.45 2 12 2Z" />
</svg>
`;

// Convert SVG content to a data URI
const svgDataUri = `data:image/svg+xml,${encodeURIComponent(svgContent)}`;
const [expanded, setExpanded] = useState(false);

useEffect(() => {
  // This code runs after 'expanded' change
  // Place your desired code here
  if(storeValue){
    storeValue.update.tree({tree_position: 'inherit',contract:!expanded})
  }
}, [expanded]);


  return (
      <div>
      <button className="download-btn" onClick={handleInvite} style={{ width: '40px', height: '40px', padding: '4px' }}>
      <img src={download} alt="SVG as Image" style={{ width: '100%', height: '100%' }}  />
      </button>
      <InviteForm
        isOpen={isModalOpen}
        onClose={closeModal}
        onInvite={handleInvite}
        onCancel={handleCancel}
        mobile={mobile}
        onInputChange={handleInputChange}
        accessToken={props.accessToken}
        refreshToken={props.refreshToken}
        axiosAppInstance={props.axiosAppInstance}
        passPaymentEventToApp={passPaymentEventToApp}
        initiateDownload={initiateDownload}
        selectLanguage={selectLanguage}
        selectCurrency={selectCurrency}
        flag={flag}
        popupStep={popupStep}
        setPopupStep={setPopupStep}
        exportType={exportType}
        setExportType={setExportType}
        hasExceededLimit={hasExceededLimit}
      />
         {(fitTree || DownloadSubscriber) && (<ModeToggleButton 
      member_id={member_id}
      setExpanded={setExpanded}
      expanded={expanded}
      mode={0}
      isBefore={isBefore}
      hasExceededLimit={hasExceededLimit}
      DownloadSubscriber={DownloadSubscriber}
      fitTree={fitTree}
       />)}
    </div>
  );
}

export default Invite;
